import { render, staticRenderFns } from "./TourOverlay.vue?vue&type=template&id=5d10972c&scoped=true"
import script from "./TourOverlay.vue?vue&type=script&lang=js"
export * from "./TourOverlay.vue?vue&type=script&lang=js"
import style0 from "./TourOverlay.vue?vue&type=style&index=0&id=5d10972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10972c",
  null
  
)

export default component.exports